// src/features/subtitles/subtitlesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to fetch subtitles from the backend.
export const fetchSubtitles = createAsyncThunk(
    'subtitles/fetchSubtitles',
    async (downloadToken) => {
      const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';
      const response = await fetch(`${baseUrl}/api/v1/home/get_subtitles?token=${downloadToken}`, { credentials: 'include' });
      const data = await response.json();
      console.log('fetchSubtitles - Fetched data:', data);
      return data.subtitles;
    }
  );
  
const subtitlesSlice = createSlice({
  name: 'subtitles',
  initialState: {
    subtitles: [],
    currentSubtitleIndex: 0,
    status: 'idle',
    error: null,
  },
  reducers: {
    updateSubtitle(state, action) {
      const { id, text } = action.payload;
      const index = state.subtitles.findIndex(s => s.id === id);
      if (index !== -1) {
        state.subtitles[index].text = text;
        console.log(`updateSubtitle - Updated subtitle id ${id} with text:`, text);
      }
    },
    setCurrentSubtitleIndex(state, action) {
      state.currentSubtitleIndex = action.payload;
      console.log('setCurrentSubtitleIndex - New index:', action.payload);
    },
    setSubtitles(state, action) {
      state.subtitles = action.payload;
      console.log('setSubtitles - Subtitles set to:', action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubtitles.pending, (state) => {
        state.status = 'loading';
        console.log('fetchSubtitles.pending - Loading subtitles...');
      })
      .addCase(fetchSubtitles.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.subtitles = action.payload;
        console.log('fetchSubtitles.fulfilled - Subtitles received:', action.payload);
      })
      .addCase(fetchSubtitles.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
        console.error('fetchSubtitles.rejected - Error:', action.error.message);
      });
  }
});

export const { updateSubtitle, setCurrentSubtitleIndex, setSubtitles } = subtitlesSlice.actions;
export default subtitlesSlice.reducer;
